import { NumberField } from "./NumberField";

export function FontSizeField({
  value,
  fallbackValue,
  min,
  max,
  onCommit,
}: {
  value: number | "mixed";
  fallbackValue: number;
  min: number;
  max: number;
  onCommit: (fontSize: number) => void;
}) {
  return (
    <NumberField
      label="Size"
      value={value === "mixed" ? fallbackValue : value}
      mixed={value === "mixed"}
      min={min}
      max={max}
      onCommit={onCommit}
    />
  );
}
